/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_SearchInputs */

const vi_shop_account_search = /** @type {(inputs: Shop_Account_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm email / SĐT / Zalo ID / họ tên…`)
};

/**

* @param {Shop_Account_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_search = /** @type {((inputs?: Shop_Account_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_search(inputs)
});